<template>
  <div>
    <Card>
      <!-- <Row>
        <Col span="4">商品名</Col>
        <Col span="4" offset="1">{{ product.name }}</Col>
      </Row>
      <br />
      <Row>
        <Col span="4">当前数量： </Col>
        <Col span="4"><Input type="text" v-model="product.stocks"/></Col>
        <Col span="4" offset="1"
          ><Button type="info" @click="check">盘</Button></Col
        >
      </Row> -->
      <TablePaginate
        :columns="columns"
        :data="stocks_all"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: i18n.t('pages_stocks_index_1129'),
          key: 'created_at_str',
          align: 'center',
          width: 200
        },
        {
          title: i18n.t('pages_stocks_index_1130'),
          key: 'fresh_product_name',
          align: 'center'
        },
        {
          title: i18n.t('pages_stocks_index_1131'),
          key: 'user_name',
          align: 'center',
          width: 220
        },
        {
          title: i18n.t('pages_stocks_index_1132'),
          key: 'stocks',
          align: 'center',
          width: 220
        }
      ]
    }
  },
  created () {
    // this.show(this.$route.params.id)
    // this.index({ product_id: this.$route.params.id })
    this.all_index()
  },
  computed: {
    ...mapGetters('stock', ['stocks_all', 'meta', 'loading']),
    ...mapGetters('product', ['product'])
  },
  methods: {
    ...mapActions('stock', ['all_index', 'create']),
    ...mapActions('product', ['show']),
    ...mapMutations('stock', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page })
      this.all_index()
    }
  }
}
</script>
